<div class="container-sm tickets-container">

  <h2 class="page-title">Mis Reservas</h2>

  <div *ngIf="tickets.length; else emptyState">

    <div class="ticket-card" *ngFor="let ticket of tickets">

      <div class="ticket-info">
        <div class="ticket-route">
          {{ ticket.routeName }}
        </div>

        <div class="ticket-date">
          {{ ticket.time | date:'dd/MM/yyyy HH:mm' }}
        </div>
      </div>

      <button class="btn-cancel"
              (click)="cancel(ticket)">
        Cancelar
      </button>

    </div>

  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      No reservaste pasajes para los próximos días.
      <a routerLink="/steps/route">Reservar ahora</a>
    </div>
  </ng-template>

</div>